<template>
  <div
    class="horizontal-product-main"
    id="recommendedItems"
    :class="{ 'shimmer-border pb24': showExtraDiv }"
  >
    <div v-if="showExtraDiv">
      <p class="shimmer-container c1 mb16"></p>
      <p class="shimmer-container c2"></p>
    </div>
    <h3
      v-else
      class="card-catg-name shimmer-container hide-shimmer-text"
      style="width: auto"
    >
      Recommendation
    </h3>
    <section class="carousel" dir="ltr" aria-label="Gallery">
      <div class="carousel__viewport">
        <ol
          class="carousel__track"
          style="transform: translateX(0px); transition: all 0ms ease 0s"
        >
          <li
            class="carousel__slide carousel__slide--active carousel__slide--visible"
            style="order: 0"
          >
            <div
              class="card-item options-api mr12"
              id="undefined"
              data-v-52270af6=""
            >
              <div class="observer" data-v-52270af6=""></div>
              <div class="card-size card-rounded" data-v-52270af6="">
                <div class="c-img-wrap shimmer-container" data-v-52270af6="">
                  <div class="card-img img-product-home"></div>
                </div>
              </div>
            </div>
          </li>
          <li
            class="carousel__slide carousel__slide--active carousel__slide--visible"
            style="order: 0"
          >
            <div
              class="card-item options-api mr12"
              id="undefined"
              data-v-52270af6=""
            >
              <div class="observer" data-v-52270af6=""></div>
              <div class="card-size card-rounded" data-v-52270af6="">
                <div class="c-img-wrap shimmer-container" data-v-52270af6="">
                  <div class="card-img img-product-home"></div>
                </div>
              </div>
            </div>
          </li>
        </ol>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: ["type"],
  data() {
    return {
      showExtraDiv: false,
    };
  },
  mounted() {
    if (this.type) {
      this.showExtraDiv = true;
    }
  },
};
</script>
